import type { components } from '@/types/api-schema';

export type AppNotificationType = components['schemas']['AppNotificationType'];

/**
 * アプリ内通知の種別定数
 *
 * `satisfies` の型に mapped type を使うことで、SSOT（OpenAPI 生成型）に新しい
 * AppNotificationType 値が追加された際に、このオブジェクトの項目不足がコンパイル
 * エラーとして検出される。キー名は値の uppercase と一致させる必要がある。
 */
export const APP_NOTIFICATION_TYPE = {
  PARTICIPANT_JOINED: 'participant_joined',
  PARTICIPANT_UPDATED: 'participant_updated',
  COMMENT_ADDED: 'comment_added',
  EVENT_CHANGED: 'event_changed',
  EVENT_CANCELLED: 'event_cancelled',
  SYSTEM_ANNOUNCEMENT: 'system_announcement',
} as const satisfies { [K in AppNotificationType as Uppercase<K>]: K };

// 種別の日本語ラベル
export const APP_NOTIFICATION_TYPE_LABEL: Record<AppNotificationType, string> = {
  [APP_NOTIFICATION_TYPE.PARTICIPANT_JOINED]: '参加登録',
  [APP_NOTIFICATION_TYPE.PARTICIPANT_UPDATED]: '回答更新',
  [APP_NOTIFICATION_TYPE.COMMENT_ADDED]: 'コメント',
  [APP_NOTIFICATION_TYPE.EVENT_CHANGED]: 'イベント変更',
  [APP_NOTIFICATION_TYPE.EVENT_CANCELLED]: 'イベント中止',
  [APP_NOTIFICATION_TYPE.SYSTEM_ANNOUNCEMENT]: '運営からのお知らせ',
};

/**
 * 未読数ポーリングの間隔設定
 *
 * ポーリングはタブがアクティブなときだけ動かす。ページアクセスから最初の5分間は
 * 3分間隔、以降は経過時間が倍になるごとに間隔も倍にして最長2時間まで広げる。
 * タブに戻ってきたときは、直近の取得から NOTIF_POLL_BASE_MS 以上経っていれば取り直す。
 */
export const NOTIF_POLL_BASE_MS = 180_000;
export const NOTIF_POLL_BASE_PHASE_MS = 300_000;
export const NOTIF_POLL_MAX_MS = 7_200_000;
